import { keyframes, styled } from "@mui/material";
import ChatbotIcon from "./ChatbotIcon";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-6px);
  }
`;

const TypingLoaderWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "14px",
  fontFamily: "sans-serif",
  alignSelf: "flex-start",
  padding: "10px",
  margin: "5px 10px",
  flexDirection: "row",
  marginTop: "8px",
});

const DotsWrapper = styled("span")({
  display: "flex",
  gap: "4px",
  marginLeft: "8px",
});

const Dot = styled("span")(({ delay }) => ({
  width: "6px",
  height: "6px",
  borderRadius: "50%",
  backgroundColor: "#555",
  display: "inline-block",
  animation: `${bounce} 1.2s infinite ease-in-out`,
  animationDelay: `${delay}s`,
}));

const ChatbotLoaderUnstyled = () => (
  <TypingLoaderWrapper>
    <ChatbotIcon sx={{ fontSize: "2rem", color: "#EC9D3E" }} />
    <DotsWrapper>
      <Dot delay={0} />
      <Dot delay={0.2} />
      <Dot delay={0.4} />
    </DotsWrapper>
  </TypingLoaderWrapper>
);

const ChatbotLoader = styled(ChatbotLoaderUnstyled)({});

export default ChatbotLoader;
